import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';


type SWChildDeviceRegistrationEndpointSpecification = ApiEndpointSpecification;
export const SWChildDeviceRegistrationEndpointSpecification: SWChildDeviceRegistrationEndpointSpecification = {
    url: '/api/sierradevice/register/childdevice',
    method: HttpMethod.POST,
    requestParamsSchemaName: 'SwChildDeviceRegistrationRequestParams',
    requestBodySchemaName: 'SwChildDeviceRegistrationRequestBody',
    okResponseSchemaName: 'SwChildDeviceRegistrationOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version : 1
};

export const invokeSWChildDeviceRegistration = Helpers.makeApiRequestFn<
    Types.SWChildDeviceRegistrationRequestParams,
    Types.SWChildDeviceRegistrationRequestBody,
    Types.SWChildDeviceRegistrationOkResponse
>(SWChildDeviceRegistrationEndpointSpecification);
